import { render } from "./ResetearContrasena.vue?vue&type=template&id=bc6a80e8"
import script from "./ResetearContrasena.vue?vue&type=script&lang=js"
export * from "./ResetearContrasena.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__